import { render, staticRenderFns } from "./AssetEditModal.vue?vue&type=template&id=28610f48&scoped=true"
import script from "./AssetEditModal.vue?vue&type=script&lang=js"
export * from "./AssetEditModal.vue?vue&type=script&lang=js"
import style0 from "./AssetEditModal.vue?vue&type=style&index=0&id=28610f48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28610f48",
  null
  
)

export default component.exports